import { Center, Column, Screen } from '@tempmee/react';
import { CenteredSpinner, Pagination } from '~/commonComponents';
import { NoScreen } from '~/components/shared/NoScreen';
import {
  IDraftJobPostListViewEntity,
  IJobPostEntity,
  JobPostingStatus,
} from '~/domain/PermanentJobs';
import { DefaultTable, DraftTable, Header, SuspendedBanner } from './components';
import { useManageJobs } from './useManageJobs';

export const ManageJobs = () => {
  const {
    data,
    forms,
    initialStatus,
    isInitialLoading,
    isLoading,
    methods,
    pagination,
    statistics,
  } = useManageJobs();

  const isDraft = forms.filters.status === JobPostingStatus.Draft;

  return (
    <NoScreen>
      <Screen.Header title="Permanent Jobs" />
      <Column gap={4} width="100%">
        <SuspendedBanner counts={statistics.tabs.suspended} />
        <Header
          initialStatus={initialStatus}
          statistics={statistics.tabs}
          onValueChanges={(newValue) => {
            methods.setFormFilters(newValue);
            methods.setCurrentPage(1);
          }}
        />
        <Column px={20}>
          {isInitialLoading ? (
            <Center style={{ marginBlock: 32 }}>
              <CenteredSpinner />
            </Center>
          ) : (
            <>
              {!isDraft ? (
                <DefaultTable
                  data={data as IJobPostEntity[]}
                  formSorting={forms.sorting}
                  isLoading={isLoading}
                  onSortChanges={methods.setFormSorting}
                />
              ) : (
                <DraftTable data={data as IDraftJobPostListViewEntity[]} isLoading={isLoading} />
              )}
              <Pagination
                currentPage={pagination.currentPage}
                totalPages={pagination.totalPages}
                onPageChange={methods.setCurrentPage}
              />
            </>
          )}
        </Column>
      </Column>
    </NoScreen>
  );
};
